/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { alertActions } from '../../../_actions/alert.actions';
import { vaccineVaccinationsService } from '../../../_services/vaccine-vaccinations.service';
import SearchVaccinationsComponent from "./Components/SearchVaccinationsComponent";
import queryString from 'query-string';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import { Spinner } from 'react-bootstrap';
import VaccinationEmpty from './VaccinationEmpty';

export default function Vaccinations(props) {
  const columns = [
    {
      name: 'Status',
      sort: false,
      grow: 1,
      cell: row => {
        if (row.status === 'COMPLETED') {
          return <span className="badge bg-success text-white">COMPLETED</span>
        } else if (row.status === 'PENDING') {
          return <span className="badge bg-info text-white">PENDING</span>
        }
      }
    },
    {
      name: 'Location',
      sort: false,
      grow: 2,
      cell: vaccination => vaccination.location
    },
    {
      name: 'Name',
      sort: false,
      grow: 2,
      cell: vaccination => `${vaccination.firstName} ${vaccination.lastName}`
    },
    {
      name: 'Date of Birth',
      sort: false,
      cell: vaccination => moment(vaccination.dateOfBirth).local().format('L'),
      grow: 2
    },
    {
      name: 'Created At',
      sort: false,
      cell: vaccination => moment.tz(vaccination.createdAt.date, vaccination.createdAt.timezone).local().format('l LT'),
      grow: 2
    },
    {
      button: true,
      sort: false,
      width: '200px',
      cell: vaccination => {
        return <>
          <Link to={`/vaccine/cair/view/${vaccination.id}`} className="btn btn-outline-primary" >View</Link>
          <Link to={`/vaccine/cair/edit/${vaccination.id}`} className="btn btn-outline-primary ml-2">Edit</Link>
        </>
      }
    }
  ]

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [initLoad, setInitLoad] = useState(true)
  const [totalRows, setTotalRows] = useState(0);
  const [vaccinations, setVaccinations] = useState([]);

  function retrieveVaccinations(params = null) {
    setLoading(true);
    vaccineVaccinationsService.getAll(params)
      .then(data => {
        setLoading(false);
        setTotalRows(data.total);
        setVaccinations(data.collection.data);
        setInitLoad(false)
      })
      .catch(() => {
        setLoading(false);
        dispatch(alertActions.error('Could not load CAIR record. Please try again.'));
      });
  }

  function getQueryParams(page = '') {
    let queryParams = queryString.parse(props.location.search);
    const providerLocation = JSON.parse(localStorage.getItem('providerLocation'));

    if (page) {
      queryParams.page = page;
    }
    props.history.replace(`?${queryString.stringify(queryParams)}`);

    queryParams.location = providerLocation ? providerLocation : '';
    queryParams.status = queryParams.status ? queryParams.status : '';
    queryParams.firstName = queryParams.firstName ? queryParams.firstName : '';
    queryParams.lastName = queryParams.lastName ? queryParams.lastName : '';
    queryParams.dateOfBirth = dateToYYYYMMDD(queryParams.dateOfBirth);

    return queryParams;
  }

  function dateToYYYYMMDD(dob) {
    return dob ? dob.replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$3-$1-$2") : '';
  }

  useEffect(() => {
    const historyState = props.history.location.state;
    if (historyState && historyState.completed) {
      dispatch(alertActions.success('CAIR successfully updated!'));
    }
    const params = getQueryParams();

    retrieveVaccinations(params);
  }, []);

  return <div className="mt-4">
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item active" aria-current="page">CAIR</li>
      </ol>
    </nav>

    {initLoad && loading ?
      <Spinner animation="border" role="status" />
      :
      initLoad && vaccinations.length === 0 ?
        <VaccinationEmpty />
        :
        <DataTable
          columns={columns}
          data={vaccinations}
          overflowY={true}
          progressPending={loading}
          onChangePage={page => {
            setLoading(true);
            const params = getQueryParams(page);
            retrieveVaccinations(params);
          }}
          subHeader={true}
          subHeaderComponent={
            <SearchVaccinationsComponent
              windowLocation={props.location}
              handleClear={() => { retrieveVaccinations() }}
              handleSearch={(params) => {
                const { location, status, firstName, lastName, dateOfBirth } = params;
                props.history.replace(`?location=${location}&status=${status}&firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}`);
                params.dateOfBirth = dateToYYYYMMDD(params.dateOfBirth);

                if (props.history.location.search !== props.location.search) {
                  retrieveVaccinations(params);
                }
              }} />
          }
          striped={true}
          pagination={true}
          paginationServer={true}
          paginationTotalRows={totalRows}
          paginationRowsPerPageOptions={[15]}
          paginationPerPage={15}
          noDataComponent={<div className="p-4">We could not find any results based on your search criteria</div>}
          customStyles={{ cells: { style: { fontSize: '14px' }, }, }}
        />
    }

  </div>
}